/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import "./ReviewForm.css";
import { isLoggedIn } from "../../../utils/UtilityFunctions";
import { useNavigate } from "react-router-dom";
import {
  onGetReviews,
  onReviewPost,
  onReviewPostReset,
} from "../../../Store/Slices/reviewSlice";
import { useAppDispatch, useReviewData, useUserData } from "../../../Utility";
import toast from "react-hot-toast";
import { onGetBusinesses } from "../../../Store/Slices/businessSlice";

const STAR_COUNT = 5;

function ReviewForm({ entityType = "venue", entityId, entityName, onSubmit }) {
  const [rating, setRating] = useState(null);
  const [hoverRating, setHoverRating] = useState(null);
  const [reviewText, setReviewText] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const isLogin = isLoggedIn();
  const dispatch = useAppDispatch();
  const reviewData = useReviewData();
  const userData = useUserData();
  const displayRating = hoverRating !== null ? hoverRating : rating;
  const label = entityType === "venue" ? "Rate this venue" : "Rate this vendor";

  const handleSubmit = async (e) => {
    if (!isLogin) {
      navigate("/login");
      return;
    }
    e.preventDefault();
    if (rating == null) return;
    dispatch(
      onReviewPost({
        business_id: entityId,
        rating: rating,
        user_id: userData?.id,
        review: reviewText.trim() || undefined,
      }),
    );
  };
  useEffect(()=>{
    onGetReviews({business_id:entityId});
    },[])
  useEffect(() => {
    if (reviewData.postStatusCode === "201") {
      setSubmitted(true);
      setRating(null);
      setHoverRating(null);
      setReviewText("");
      dispatch(onReviewPostReset());
      dispatch(onGetReviews({business_id:entityId}));
      dispatch(onGetBusinesses({ limit: 50, offset: 0 }));
      toast.success("Review submitted successfully");
    } else if(reviewData.postStatusCode === '400'){
      dispatch(onReviewPostReset());

      setRating(null);
      setHoverRating(null);
      setReviewText("");
      toast.error(reviewData.postMessage);
    }
  }, [reviewData.postStatusCode, reviewData.postMessage, dispatch, setIsSubmitting, setRating, setHoverRating, setReviewText]);

  if (submitted) {
    return (
      <section className="venue-section review-form-section">
        <p className="review-form-success">
          Thanks! Your rating has been submitted.
        </p>
      </section>
    );
  }

  const isLoading = reviewData?.postLoading === true;

  if (isLoading) {
    return (
      <section
        className="venue-section review-form-section review-form-section-skeleton"
        aria-busy="true"
        aria-label="Loading review form"
      >
        <div className="review-form-skeleton-title skeleton-pulse" />
        <div className="review-form-skeleton-hint skeleton-pulse" />
        <div className="review-form-skeleton-form">
          <div className="review-form-skeleton-stars-wrap">
            <div className="review-form-skeleton-label skeleton-pulse" />
            <div className="review-form-skeleton-stars">
              {[...Array(STAR_COUNT)].map((_, i) => (
                <div key={i} className="review-form-skeleton-star skeleton-pulse" />
              ))}
            </div>
          </div>
          <div className="review-form-skeleton-text-wrap">
            <div className="review-form-skeleton-label skeleton-pulse" />
            <div className="review-form-skeleton-textarea skeleton-pulse" />
          </div>
          <div className="review-form-skeleton-submit skeleton-pulse" />
        </div>
      </section>
    );
  }

  return (
    <section
      className="venue-section review-form-section"
      aria-labelledby="review-form-heading"
    >
      <h2 id="review-form-heading" className="venue-section-title">
        {label}
      </h2>
      <p className="review-form-hint">
        Stars are required. You can add a comment below (optional).
      </p>
      <form className="review-form" onSubmit={handleSubmit}>
        <div className="review-form-stars-wrap">
          <span className="review-form-stars-label">Your rating</span>
          <div
            className="review-form-stars"
            role="group"
            aria-label="Rate 1 to 5 stars"
          >
            {[...Array(STAR_COUNT)].map((_, i) => {
              const value = i + 1;
              const filled = value <= displayRating;
              return (
                <button
                  key={value}
                  type="button"
                  className={`review-form-star-btn ${value <= displayRating ? "filled" : ""}`}
                  aria-label={`${value} star${value !== 1 ? "s" : ""}`}
                  aria-pressed={rating === value}
                  onClick={() => setRating(value)}
                  onMouseEnter={() => setHoverRating(value)}
                  onMouseLeave={() => setHoverRating(null)}
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill={filled ? "currentColor" : "none"}
                    stroke="currentColor"
                    strokeWidth="2"
                    aria-hidden
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                </button>
              );
            })}
          </div>
          {rating != null && (
            <span className="review-form-stars-value">{rating} of 5</span>
          )}
        </div>
        <div className="review-form-text-wrap">
          <label htmlFor="review-form-text" className="review-form-text-label">
            Comment (optional)
          </label>
          <textarea
            id="review-form-text"
            className="review-form-text"
            placeholder="Share your experience..."
            value={reviewText}
            onChange={(e) => setReviewText(e.target.value)}
            rows={4}
            maxLength={2000}
          />
        </div>
        <button
          type="submit"
          className="review-form-submit"
          disabled={rating == null || isSubmitting}
        >
          {isSubmitting ? "Submitting…" : "Submit rating"}
        </button>
      </form>
    </section>
  );
}

export default ReviewForm;
